import React from 'react';

import AboutPage from 'components/AboutPage/AboutPage';
import websitePage from 'hoc/websitePage/websitePage';

import SectionInconformados from './patterns/SectionInconformados/SectionInconformados';
import SectionImages from './patterns/SectionImages/SectionImages';
import SectionDifferent from './patterns/SectionDifferent/SectionDifferent';
import SectionCareers from './patterns/SectionCareers/SectionCareers';

function AboutUs() {
  return (
    <AboutPage>
      <SectionInconformados />
      <SectionImages />
      <SectionDifferent />
      <SectionCareers />
    </AboutPage>
  );
}

export default websitePage({
  routeKey: 'ABOUT_US',
})(AboutUs);
